<template>
  <div style="display: flex; flex-direction: column" :key="compKey">
    <Toggle
      v-model="isEnable"
      onLabel="Enabled"
      offLabel="Disabled"
      @change="toggleStatus"
      :disabled="loading"
    />
  </div>
</template>

<script>
import Toggle from "@vueform/toggle";
import api from "@/api/index";

export default {
  name: "tableDateFormatter",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  components: {
    Toggle,
  },
  data() {
    return {
      isEnable: null,
      loading: false,
      compKey: 0
    };
  },
  watch: {
    data(oldVal, newVal) {
      if(this.data) {
        setTimeout(()=>{
          this.isEnable = this.data.isEnable;
        }, 100);
      }
    }
  },
  created() {
    this.isEnable = this.data.isEnable;
    ++this.compKey;
  },
  // watch: {
  //   isEnable(newValue, oldValue) {
  //     this.toggleStatus();
  //   },
  // },
  methods: {
    async toggleStatus(value) {
      const body = {
        id: this.data.id,
        enable: value,
      };
      this.loading = true;
      const res = await api.alarms.UpdateConditionStatus(body);
      this.loading = false;
    },
  },
};
</script>
<style src="@vueform/toggle/themes/default.css"></style>

<style>
.toggle {
  margin-top: -6px;
}
.toggle .toggle-label {
  position: absolute;
  left: 0px;
  top: 26px;
  z-index: 9;
  color: #8e8e8e;
  font-size: 14px;
  opacity: 0.65;
}

.toggle.toggle-on {
  border-color: transparent;
  background: #4c8dbb73 !important;
}

.toggle .toggle-handle {
  background: #4c8dbb;
  opacity: 0.35;
}

.toggle.toggle-on .toggle-handle {
  opacity: 1;
}

.toggle.toggle-on .toggle-label {
  color: #8e8e8e;
  opacity: 1;
}
</style>
